"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMainMenuCharacterSelectState = void 0;
const getMainMenuState_1 = require("./getMainMenuState");
const getMainMenuCharacterSelectState = () => {
    const mainMenuState = (0, getMainMenuState_1.getMainMenuState)();
    if (mainMenuState.values.characterSelectState === null) {
        throw new Error("characterSelectState is null");
    }
    return mainMenuState.values.characterSelectState;
};
exports.getMainMenuCharacterSelectState = getMainMenuCharacterSelectState;
